import { Getter, GetterTree } from "vuex";
import { Answer, Question, questions } from "@/data/questions";

import { State } from "./state";

export type GetterValues = {
  [K in keyof Getters]: ReturnType<Getters[K]>;
};

export type Getters = {
  currentQuestion(state: State, getters: GetterValues): Question;
  score(state: State, getters: GetterValues): number;
  selectedAnswers(state: State, getters: GetterValues): Answer[];
};

export const getters: GetterTree<State, State> & Getters = {
  currentQuestion(state) {
    return questions[state.questionId];
  },
  score(state) {
    return (
      state.carbonFootprint +
      state.economicProsperity +
      state.employment +
      state.healthHappinessAndWellbeing +
      state.wildlife
    );
  },
  selectedAnswers(state) {
    return state.selectedAnswers;
  },
};
